<button 
    class="mat-flat-button" 
    (click)="togglePanel()">
    Customize Fields
</button>
<mat-card [ngClass]="{open: panelOpen}">
    <mat-card-content>
        <div class="column" *ngFor="let column of fs.fields | doNotFilter: fs.doNotFilter | orderBy: 'name'; let i = index">
            <mat-checkbox [(ngModel)]="column.visible" (change)="fs.updateColumns()">{{column.name}}</mat-checkbox>
        </div>
    </mat-card-content>
</mat-card>